import { TaskAltOutlined } from '@mui/icons-material';
import {
  alpha,
  Box,
  darken,
  Icon,
  lighten,
  Typography,
  useTheme,
} from '@mui/material';

export default function CourseContentItem({
  active,
  completed,
  title,
  duration,
  icon,
  onClick,
}) {
  const theme = useTheme();
  return (
    <Box
      className={active ? 'active' : ''}
      onClick={!active ? onClick : undefined}
      sx={{
        borderRadius: 1,
        py: 1,
        px: 2,
        position: 'relative',
        borderLeft: `4px solid transparent`,
        '&:hover': {
          backgroundColor: darken(theme.palette.background.paper, 0.05),
        },
        '&:active': {
          backgroundColor: darken(theme.palette.background.paper, 0.1),
        },
        '&.active': {
          backgroundColor: alpha(theme.palette.primary.main, 0.05),
          borderLeft: `4px solid ${theme.palette.primary.main}`,
        },
        cursor: !active ? 'pointer' : 'default',
        userSelect: 'none',
      }}
    >
      {icon && <Icon sx={{
        color: lighten(theme.palette.text.secondary, 0.2),
        fontSize: 18,
      }}>{icon}</Icon>}
      <Typography sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {duration}
      </Typography>
      {completed && (
        <TaskAltOutlined
          sx={{
            color: lighten(theme.palette.success.main, 0.3),
            position: 'absolute',
            top: 0,
            right: 0,
            m: 1,
            fontSize: 20,
          }}
        />
      )}
    </Box>
  );
}
